export const OPTIONAL_AND_CONTINUED_OFFICE_CODE = "9999" as const;

export const DEFAULT_TIMEZONE = "Asia/Tokyo";
export const DEFAULT_DATE_FORMAT = "YYYY/MM/DD";
export const DEFAULT_DATETIME_FORMAT = "YYYY/MM/DD HH:mm";
